module.exports = __webpack_public_path__ + "img/6a9a82e.jpg";